import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import AirCargo from './AirCargo';
import Chartered from './Chartered';
import GSA from './GSA';


const Aviation = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
    return(
        <div>
            <div id='international' className="aviation-image">
                <img src='/aviation/main-banner.jpg' alt='banner' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    TCS Aviation division specialises in delivering customised air freight solutions for freight forwarders, 
                    pharmaceutical industry, charities & relief organisations, government departments, airlines, general 
                    sales agents, oil & automotive industries and brokers. TCS Aviation, with its dedicated air fleet and 
                    international offices in Pakistan, the UAE and the UK, assures that all its air freight & charter 
                    requirements are fulfilled.
                </p>
                
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="sm:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/aviation/gsa"  className='font-bold'>GSA</Link></li>
                            </div>
                            

                           
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/aviation/air-cargo" className='font-bold'>Air Cargo</Link></li>
                            </div>
                        
                        </div>
                        <div className="flex-1 flex flex-col">
                        <div className="flex items-center">
                                <li><Link to="/aviation/chartered" className='font-bold'>Chartered</Link></li>
                            </div>
                        
                        </div>
                            
                    </div>
                </div>
               
                 
            </div>
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="gsa">
                <GSA />
            </div>
            <div id="air-cargo">
                <AirCargo />
            </div>
            <div id="chartered">
                <Chartered />
            </div>
            </div>
            {/* <div id="rush-delivery">
            <RushDelivery />
            </div> */}

        </div>
    )
};
export default Aviation;